module.exports = __webpack_public_path__ + "static/img/14.ff215346.jpg";